import { IBrand } from "@faire/web-api--source/indigofair/data/IBrand";
import { createContextStore } from "@faire/web/common/hooks/ContextStore/createContextStore";

interface BrandsLandingPageState {
  brandToken: string | undefined;
  existingEmail: string | undefined;
  showBanner: boolean;
  email: string | undefined;
  brand: IBrand | undefined;
  isLoading: boolean;
  salesforceOwnerUrl: string | undefined;
  isMarketSectionVisible: boolean;
}

const INITIAL_STATE: BrandsLandingPageState = {
  brandToken: undefined,
  existingEmail: undefined,
  showBanner: false,
  email: undefined,
  brand: undefined,
  salesforceOwnerUrl: undefined,
  isLoading: false,
  isMarketSectionVisible: false,
};

const {
  useStore: useBrandsLandingPageStore,
  Provider: BrandsLandingPageProvider,
} = createContextStore(INITIAL_STATE, {
  name: "BrandsLandingPageContext",
});

export { useBrandsLandingPageStore, BrandsLandingPageProvider };
